<template>
  <div
    class="h-64 bg-gray-300 overflow-hidden relative cursor-pointer"
    @click="openDetails"
  >
    <single-image :image="newsEntry.image || category.image" />
    <div
      class="absolute inset-0 group-hover:opacity-50 transition-opacity duration-150"
      :style="{
        background:
          'linear-gradient(0deg, ' +
          hexToRgbA(category.color, 0.8) +
          ' 0%, ' +
          hexToRgbA(category.color, 0) +
          ' 80%)',
      }"
    />
    <div class="z-20 text-white tracking-wider grid grid-cols-auto-1 gap-2">
      <div
        class="absolute bottom-0 inset-x-0 z-30 p-4 grid grid-cols-1-auto"
        :style="{
          textShadow:
            '2px 2px 6px ' +
            hexToRgbA(category.color, 1) +
            ', 1px 1px 4px rgba(0,0,0,0.8)',
        }"
      >
        <div>
          <h2 class="mb-0 leading-tight">
            {{ newsEntry.title }}
          </h2>
          <p class="font-light">
            {{ momentFormat(newsEntry.published_at, "DD.MM.YYYY") }}
          </p>
        </div>
        <div class="self-end">
          <icon :name="category.icon" size="1.8em" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";
import { NewsEntry } from "@/modules/home/viewmodels/NewsEntry";
import { NewsCategory } from "@/modules/home/viewmodels/NewsCategory";

const SingleImage = require("@/modules/images/components/SingleImage.vue")
  .default;

export default {
  name: "News",
  mixins: [DateMixin],
  data() {
    return {};
  },
  props: {
    newsEntry: {
      type: NewsEntry,
      default: null,
    },
    category: {
      type: NewsCategory,
    },
  },
  components: {
    SingleImage,
  },
  methods: {
    openDetails() {
      let link = this.newsEntry.slug || this.newsEntry.id;
      this.$router.push("/home/news/" + link);
    },
    hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          ", " +
          opacity +
          ")"
        );
      }
      throw new Error("Bad Hex");
    },
  },
  computed: {},
  created() {},
};
</script>
